import { PrimaryButton } from './Button';
import createTagButton from '../../../utils/helpers/createTagButton';

const BlueCommonBtn = createTagButton(PrimaryButton, { defaultType: 'submit' });

export default BlueCommonBtn;
